export default "__VITE_ASSET__DIMxGVox__"